import React, { useCallback } from 'react';

import Input from '@ott/input';
import { l10n } from '@ott/l10n';
import cardValidator from '@ott/utility-card-validator';

import { cardBinLength, dataLocators, fieldsNames, maxCVVLength } from '../../../constants';
import { transforms, checkIsSecuritySupported } from '../../../helpers';
import { useCreditCardContext } from '../../../provider';
import { VirtualCardCodeButton } from './blocks/VirtualCardCodeButton';

import styles from './CVVInput.scss';

const isSecuritySupported = checkIsSecuritySupported();

export const CVVInput = () => {
  const {
    cardToDisplay,
    changeFieldValue,
    focusFieldByName,
    touchField,
    checkIfFieldInvalid,
    isVirtualCard,
  } = useCreditCardContext();

  const handleCVVChange = useCallback(
    (value: string) => {
      changeFieldValue(fieldsNames.cvv, value);

      const { card } = cardValidator.number(cardToDisplay?.cardNumber.slice(0, cardBinLength));

      const CVVLength = card?.code?.size || maxCVVLength;

      if (value.length >= CVVLength) {
        focusFieldByName(fieldsNames.cardHolder);
      }
    },
    [cardToDisplay, changeFieldValue, focusFieldByName]
  );

  return (
    <div className={styles.cvvWrapper}>
      <Input
        formatter={transforms[fieldsNames.cvv].format}
        parser={transforms[fieldsNames.cvv].parse}
        className={styles.cvv}
        childrenClassNames={{
          input: styles.cvvInput,
        }}
        label={l10n('paymentCardNew.cvvPlaceholder')}
        autoComplete="cc-csc"
        name={fieldsNames.cvv}
        value={cardToDisplay[fieldsNames.cvv]}
        onChange={handleCVVChange}
        onBlur={() => touchField(fieldsNames.cvv)}
        hasError={checkIfFieldInvalid(fieldsNames.cvv)}
        inputMode="numeric"
        type={!isSecuritySupported ? 'password' : undefined}
        specificLocators={dataLocators.cvv}
      />
      {isVirtualCard && <VirtualCardCodeButton />}
    </div>
  );
};
